import React, { useCallback } from 'react';
import { FiLink2 } from 'react-icons/fi';

import { DashMenuOptionsProps } from '@/screens/Dashboard/interfaces';
import serializeFilter from '@services/query/serializeFilters';
import { CellTypeProps } from '../../interfaces';
import { ValueArea } from './styles';

const Redirect: React.FC<CellTypeProps> = ({ dashMenuOptions, url_object }) => {
  const parsedFilters = serializeFilter(url_object.redirect_filter);
  let selectedDashboard: any = null;

  dashMenuOptions?.forEach((dash: DashMenuOptionsProps) => {
    if (dash.children) {
      Object.entries(dash.children).forEach(([key, value]) => {
        if (key.toUpperCase() === url_object.redirect_page.toUpperCase())
          selectedDashboard = value;
      });
    }
    if (dash.name.toUpperCase() === url_object.redirect_page.toUpperCase())
      selectedDashboard = dash;
  });

  const handleClick = useCallback(() => {
    if (url_object.redirect && selectedDashboard) {
      window.open(`/app/dashboard${selectedDashboard?.path}${parsedFilters}`);
    }
  }, [url_object, parsedFilters, selectedDashboard]);

  return (
    <ValueArea
      style={{ cursor: selectedDashboard && 'pointer' }}
      onClick={handleClick}
    >
      <FiLink2 size={15} />
    </ValueArea>
  );
};

export default Redirect;
